// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"062d87e6","593":"bae3465c","981":"a450572c"}[chunkId] + ".chunk.js";
};